import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { AppInsightsService } from './services/app-insights.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent],
  template: `
    <app-header></app-header>
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
    <aside class="snow-band">
      <div class="snow-band-inner">
        <span class="snow-icon" aria-hidden="true">🛠️</span>
        <span class="snow-text">Having a technical issue with this tool?</span>
        <a class="snow-btn" href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=3087225" target="_blank" rel="noopener noreferrer">Submit a ServiceNow ticket ↗</a>
      </div>
    </aside>
    <footer class="cvx-footer">
      <div class="cvx-footer-inner">
        <div class="footer-line footer-line-1">
          Last update: {{ lastUpdate }}&nbsp;&nbsp;|&nbsp;&nbsp;© {{ currentYear }} Chevron Corporation&nbsp;&nbsp;|&nbsp;&nbsp;Company Confidential
        </div>
        <div class="footer-line footer-line-2">
          Content contact: <a href="mailto:Surface-MI-IRMS@chevron.com" class="footer-link">SDP-M&amp;I-MWM</a>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
    .main-content {
      flex: 1;
      max-width: 1360px;
      margin: 0 auto;
      width: 100%;
      padding: var(--spacing-lg);
      background: var(--light-gray);
      box-sizing: border-box;
    }
    .cvx-footer {
      background: #ffffff;
      border-top: 1px solid #e0e7ef;
      padding: 0 var(--spacing-lg);
    }
    .cvx-footer-inner {
      max-width: 1360px;
      margin: 0 auto;
      padding: var(--spacing-md) var(--spacing-lg);
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      align-items: center;
      text-align: center;
    }
    .footer-line {
      font-size: 0.75rem;
      color: var(--text-muted);
    }
    .footer-line-1 {
      font-weight: 500;
    }
    .footer-link {
      color: var(--cvx-blue);
      text-decoration: none;
      font-weight: 500;
    }
    .footer-link:hover {
      text-decoration: underline;
    }
    .snow-band {
      width: 100%;
      max-width: 1360px;
      margin: 0 auto;
      padding: 0 var(--spacing-lg) var(--spacing-lg);
      box-sizing: border-box;
    }
    .snow-band-inner {
      max-width: 1280px;
      margin: 0 auto;
      background: #eef4fb;
      border: 1px solid #d6e4f5;
      border-radius: var(--radius-md, 10px);
      padding: var(--spacing-md) var(--spacing-lg);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.6rem;
      flex-wrap: wrap;
      text-align: center;
    }
    .snow-icon { font-size: 1.1rem; }
    .snow-text {
      font-size: 0.85rem;
      font-weight: 500;
      color: var(--text-primary, #1f2937);
    }
    .snow-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.3rem;
      font-size: 0.85rem;
      font-weight: 600;
      color: #ffffff;
      background: var(--cvx-blue);
      padding: 0.45rem 1.05rem;
      border-radius: 999px;
      text-decoration: none;
      transition: background 0.15s ease;
    }
    .snow-btn:hover { background: #004080; }
  `]
})
export class AppComponent implements OnInit {
  title = 'NEST NORMs Dashboard';
  readonly lastUpdate = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  readonly currentYear = new Date().getFullYear();
  appVersion = '1.0.0';

  // Eagerly construct the App Insights service at bootstrap so SPA telemetry
  // starts immediately (providedIn:'root' is otherwise lazy until first inject).
  private readonly appInsights = inject(AppInsightsService);

  ngOnInit() {
    // Version badge now also displayed in footer
  }
}
